var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 136",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#030D75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 16.6152L19.0366 20.6518C19.2508 20.866 19.5413 20.9863 19.8442 20.9863C20.1471 20.9863 20.4376 20.866 20.6518 20.6518C20.866 20.4376 20.9863 20.1471 20.9863 19.8442C20.9863 19.5413 20.866 19.2508 20.6518 19.0366L16.6137 15L20.651 10.9634C20.757 10.8574 20.8411 10.7315 20.8985 10.5929C20.9558 10.4544 20.9853 10.3059 20.9853 10.1559C20.9853 10.006 20.9557 9.85749 20.8983 9.71897C20.8409 9.58044 20.7567 9.45458 20.6507 9.34857C20.5446 9.24257 20.4187 9.15849 20.2801 9.10113C20.1416 9.04378 19.9931 9.01428 19.8431 9.01432C19.6932 9.01435 19.5447 9.04392 19.4062 9.10134C19.2677 9.15876 19.1418 9.2429 19.0358 9.34895L15 13.3855L10.9634 9.34895C10.8581 9.23985 10.7322 9.15281 10.5929 9.09291C10.4536 9.033 10.3038 9.00144 10.1522 9.00005C10.0006 8.99866 9.85027 9.02748 9.70992 9.08482C9.56958 9.14216 9.44205 9.22689 9.3348 9.33404C9.22755 9.44119 9.1427 9.56863 9.08523 9.70893C9.02775 9.84922 8.99879 9.99955 9.00004 10.1512C9.00128 10.3028 9.03271 10.4526 9.09248 10.5919C9.15226 10.7313 9.23918 10.8573 9.34818 10.9627L13.3863 15L9.34894 19.0373C9.23994 19.1427 9.15302 19.2687 9.09324 19.4081C9.03347 19.5474 9.00205 19.6972 9.0008 19.8488C8.99955 20.0004 9.02851 20.1508 9.08599 20.2911C9.14347 20.4314 9.22831 20.5588 9.33556 20.666C9.44282 20.7731 9.57034 20.8578 9.71068 20.9152C9.85103 20.9725 10.0014 21.0013 10.153 21C10.3046 20.9986 10.4544 20.967 10.5937 20.9071C10.733 20.8472 10.8589 20.7601 10.9642 20.651L15 16.6152Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.c46a425e034a8183a5b61e2d76c24bbc.svg";
export { ForwardRef as ReactComponent };